import PropTypes from "prop-types";
import "./ui.css";

export default function PageHeader({ title, description, actions }) {
  return (
    <header className="simcc-page-header">
      <div>
        <h1 className="simcc-page-header__title">{title}</h1>
        {description && <p className="simcc-page-header__description">{description}</p>}
      </div>
      {actions && <div className="simcc-page-header__actions">{actions}</div>}
    </header>
  );
}

PageHeader.propTypes = {
  title: PropTypes.node.isRequired,
  description: PropTypes.node,
  actions: PropTypes.node,
};

PageHeader.defaultProps = {
  description: undefined,
  actions: undefined,
};
